import hrmTagAssign from "./hrmTagAssign.vue";
export default hrmTagAssign;
